var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M504.733 232.029L352.459 79.755c-9.29-9.291-24.357-9.291-33.648 0-9.292 9.292-9.292 24.356 0 33.648L430.468 225.06H23.793C10.654 225.061 0 235.715 0 248.854c0 13.138 10.654 23.793 23.793 23.793h406.675L318.814 384.303c-9.292 9.294-9.292 24.357 0 33.648a23.732 23.732 0 0 0 16.824 6.97c6.09 0 12.179-2.327 16.824-6.97l152.271-152.273c9.292-9.292 9.292-24.357 0-33.649z"}));
}

ArrowInline.defaultProps = {"width":"512","height":"512","viewBox":"0 0 512 512","fill":"currentColor"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
